import { faIdCard, faToggleLargeOn } from '@fortawesome/pro-light-svg-icons'

import { AdAccountGroupModel } from '@models/adAccountGroup'

import { generateUrls } from '@hooks/useAdAccountGroup'

const generateTabBarItems = (adAccountGroup: AdAccountGroupModel) => {
  const urls = generateUrls(adAccountGroup)
  const { editAdAccountGroupUrl, editAdAccountGroupRelationsUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editAdAccountGroupUrl,
      key: 'details',
      title: adAccountGroup?.name || 'Ad Account Group Details',
    },
    {
      icon: faToggleLargeOn,
      href: editAdAccountGroupRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
  ]
}

export default generateTabBarItems
